import exampleXlsx from './example-xlsx'
import importStateIcon from './import-state-icon'
import xlsxField from './xlsx-field'
import step1 from './step1'
import step2 from './step2'
import step3 from './step3'

export default {
    exampleXlsx,
    importStateIcon,
    xlsxField,
    step1,
    step2,
    step3,
    title: 'User import via Excel document',
    tooltip: 'Open user import via Excel document',
    steps: {
        1: 'Upload file',
        2: 'Import',
        3: 'Summary'
    },
    columns: {
        email: 'E-Mail',
        salutation: 'Salutation',
        firstName: 'First name',
        lastName: 'Last name',
        jobPosition: 'Position',
        phone: 'Phone',
        roles: 'Role',
        locale: 'Language',
        locked: 'Locked',
        state: 'Status'
    }
}
